
////////////////////////////////////
// M073 focus slider

var _focusSLiderCurrentSlide

function initFocusSlider(){
    
	if($(".focus-slider").length > 0){
		
		$(".focus-slider__slider").slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 0,
            autoplay: true,
            autoplaySpeed: 5000,
            draggable: false,
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '0',
            variableWidth: false,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: _breakpointMedium,
                    settings: {
                        dots: true,
                        arrows: false,
                        draggable: true,
                        speed: 300,
                        autoplay: false,
                        prevArrow: slickPrevArrowCode,
                        nextArrow: slickNextArrowCode,
                        centerPadding: "20px",
                        adaptiveHeight: false
                    }
                }
            ]
        });

		//preload all images
		$(".focus-slider__slider").on('beforeChange', function (event, slick, currentSlide) {
			preloadFocusSliderImages();
		});
		$(".focus-slider__slider").on('afterChange', function (event, slick, currentSlide) {
            var $content = $(this).closest(".focus-slider__content");
            $content.attr("data-index", currentSlide);
            
            $content.find(".focus-slider__nav-element").removeClass("active");
            $content.find(".focus-slider__nav-element").each(function(){
                var $content = $(this).closest(".focus-slider__content");
                if($(this).attr("data-idx") == $content.attr("data-index")){
                    $(this).addClass("active");
                }
            });
            
		});

        //handle slider nav mouseenter
        $(".focus-slider__nav-element").on("mouseenter", function(){
            var x = $(this).attr("data-idx");
            $(this).siblings(".focus-slider__nav-element").removeClass("active");
            if(!$(this).hasClass("active")){
                $(this).addClass("active");

                var $sliderSection = $(this).closest(".focus-slider");
                var $slider = $sliderSection.find(".slick-slider");
                if($slider){
                    $slider.slick('slickGoTo', x);
                }
                //console.log("slick nav got to " + x);
            }
        });
	}
}

function preloadFocusSliderImages(){
	$(".focus-slider__slider").find(".focus-slider__page-image").each(function(){
		var $img = $(this).children(".b-lazy");
		if(!$img.hasClass("b-loaded") && _blazy){
			_blazy.load($img, true);
		}
	});
}

function updateFocusSlider(){
	//console.log("updatefocus-slider");
	if($(".focus-slider").length > 0){
		
		$(".focus-slider").each(function(){
			

		});
	}
}
